/* GT CRO PDP template behaviour (product.cro)
   One deferred file shared by every gt-cro-* section. No dependencies;
   uses theme.AjaxProduct (Expanse) for drawer add-to-cart when available. */
(function () {
  'use strict';

  // The asset is referenced by more than one section; run once only so
  // listeners (toggle, submit interceptor) never double-bind.
  if (window.__gtcroInit) return;
  window.__gtcroInit = true;

  function formatMoney(cents) {
    var format = document.querySelector('[data-gtcro-money-format]');
    var moneyFormat = format ? format.getAttribute('data-gtcro-money-format') : '£{{amount}}';
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  /* ---------------- scroll to buy box ---------------- */

  function scrollToBuybox() {
    var box = document.getElementById('gtcro-buybox');
    if (!box) return;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-gtcro-scroll]');
    if (!trigger) return;
    evt.preventDefault();
    var target = trigger.getAttribute('data-gtcro-scroll');
    if (target === 'buybox') {
      scrollToBuybox();
      return;
    }
    var el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------------- gallery ---------------- */

  function initGallery(root) {
    var track = root.querySelector('.gtcro-gal__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('.gtcro-gal__dot'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.gtcro-gal__thumb'));

    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === index); });
    }

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(index, slides.length - 1)));
        ticking = false;
      });
    }, { passive: true });

    root.gtcroGoTo = goTo;
  }

  /* ---------------- variant picker + buy box ---------------- */

  function initBuybox(hero) {
    var form = hero.querySelector('form.gtcro-form');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var pills = Array.prototype.slice.call(hero.querySelectorAll('.gtcro-variant'));
    var priceNow = hero.querySelector('[data-gtcro-price]');
    var priceWas = hero.querySelector('[data-gtcro-compare]');
    var saveBadge = hero.querySelector('[data-gtcro-save]');
    var scarcity = hero.querySelector('[data-gtcro-scarcity]');
    var atcBtn = form.querySelector('.gtcro-atc');
    var atcLabel = atcBtn ? atcBtn.querySelector('[data-gtcro-atc-label]') : null;
    var threshold = parseInt(hero.getAttribute('data-gtcro-scarcity-threshold') || '10', 10);
    var gallery = hero.querySelector('.gtcro-gal');

    var stickyName = document.querySelector('[data-gtcro-sticky-price]');
    var atcTotal = form.querySelector('[data-gtcro-atc-total]');

    // Bundle state: main variant price plus any staged add-ons (accessory
    // slot shared with the CRO template, pot slot used by the PDP template).
    var bundle = { price: 0, available: true, addons: [], potId: null, potPrice: 0, potSelected: false };
    hero.gtcroBundle = bundle;

    function renderTotal() {
      if (!atcTotal) return;
      if (!bundle.available) {
        atcTotal.hidden = true;
        return;
      }
      var sum = bundle.price + (bundle.potSelected ? bundle.potPrice : 0);
      bundle.addons.forEach(function (a) { sum += a.price; });
      // Optional template on the hero, e.g. "[price] —" for a price-first
      // button (PDP template). Default keeps the CRO "· £X" suffix.
      var fmt = hero.getAttribute('data-gtcro-total-fmt');
      atcTotal.innerHTML = fmt ? fmt.replace('[price]', formatMoney(sum)) : '&middot; ' + formatMoney(sum);
      atcTotal.hidden = false;
    }
    hero.gtcroRenderTotal = renderTotal;

    function applyVariant(pill, userTriggered) {
      var price = parseInt(pill.getAttribute('data-price'), 10);
      var compare = parseInt(pill.getAttribute('data-compare') || '0', 10);
      var available = pill.getAttribute('data-available') === 'true';
      var qty = parseInt(pill.getAttribute('data-qty'), 10);
      var tracked = pill.getAttribute('data-tracked') === 'true';
      var mediaIndex = parseInt(pill.getAttribute('data-media-index') || '-1', 10);

      pills.forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (idInput) idInput.value = pill.getAttribute('data-id');

      if (priceNow) priceNow.textContent = formatMoney(price);
      var hasCompare = compare > price;
      if (priceWas) {
        priceWas.textContent = hasCompare ? formatMoney(compare) : '';
        priceWas.hidden = !hasCompare;
      }
      if (saveBadge) {
        if (hasCompare) {
          var pct = Math.round((1 - price / compare) * 100);
          saveBadge.textContent = 'SAVE ' + pct + '%';
          saveBadge.hidden = false;
        } else {
          saveBadge.hidden = true;
        }
      }

      if (scarcity) {
        if (available && tracked && qty > 0 && qty <= threshold) {
          scarcity.textContent = 'Only ' + qty + ' left in stock';
          scarcity.hidden = false;
        } else {
          scarcity.hidden = true;
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !available;
        if (atcLabel) {
          atcLabel.textContent = available
            ? (atcBtn.getAttribute('data-label-add') || 'Add to basket')
            : (atcBtn.getAttribute('data-label-oos') || 'Sold out');
        }
      }

      if (stickyName) {
        var was = hasCompare ? ' <s>' + formatMoney(compare) + '</s>' : '';
        stickyName.innerHTML = formatMoney(price) + was;
      }

      if (gallery && gallery.gtcroGoTo && mediaIndex >= 0) {
        gallery.gtcroGoTo(mediaIndex);
      }

      // PDP gallery: swap the main tile to the variant's image (falling
      // back to the product's lead image) and note the selected size.
      var pdpMain = hero.querySelector('[data-gtpdp-main-img]');
      if (pdpMain) {
        var vImg = pill.getAttribute('data-variant-image');
        if (vImg) {
          pdpMain.src = vImg;
          pdpMain.srcset = pill.getAttribute('data-variant-srcset') || '';
        } else if (pdpMain.getAttribute('data-default-src')) {
          pdpMain.src = pdpMain.getAttribute('data-default-src');
          pdpMain.srcset = pdpMain.getAttribute('data-default-srcset') || '';
        }
        var sizeNote = hero.querySelector('[data-gtpdp-size-note]');
        if (sizeNote) {
          var vTitle = pill.getAttribute('data-variant-title') || '';
          sizeNote.textContent = vTitle;
          sizeNote.hidden = vTitle === '';
        }
        // On the mobile swipe gallery, centre the swap tile so the shopper
        // sees the size they just picked. Skip the initial page-load apply.
        if (userTriggered) {
          var pdpTile = pdpMain.closest('.gtpdp-gal__item');
          var pdpGal = pdpMain.closest('.gtpdp-gal');
          if (pdpTile && pdpGal && pdpGal.scrollWidth > pdpGal.clientWidth) {
            var tileRect = pdpTile.getBoundingClientRect();
            var galRect = pdpGal.getBoundingClientRect();
            var target = pdpGal.scrollLeft + (tileRect.left - galRect.left) - (galRect.width - tileRect.width) / 2;
            pdpGal.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
          }
        }
      }

      bundle.price = price;
      bundle.available = available;

      // Broadcast in the theme's own shape so add-ons (shipping estimator,
      // wishlist / back-in-stock buttons) follow the pill selection.
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: { id: parseInt(pill.getAttribute('data-id'), 10), price: price, available: available } }
      }));

      // PDP cache-pot offer follows the selected plant size band.
      if (hero.gtpdpUpdatePots) {
        hero.gtpdpUpdatePots(parseInt(pill.getAttribute('data-variant-title'), 10), pill.getAttribute('data-id'));
      }

      renderTotal();

      var instalments = hero.querySelector('[data-gtcro-instalments]');
      if (instalments) {
        var min = parseInt(instalments.getAttribute('data-min') || '0', 10);
        if (available && price >= min) {
          var amt = instalments.querySelector('[data-gtcro-instalment-amt]');
          if (amt) amt.textContent = formatMoney(Math.round(price / 3));
          instalments.hidden = false;
        } else {
          instalments.hidden = true;
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () { applyVariant(pill, true); });
    });

    var initial = hero.querySelector('.gtcro-variant.is-on') || pills[0];
    if (initial) {
      applyVariant(initial);
    } else {
      // Single-variant product: seed the bundle from the section's own data.
      bundle.price = parseInt(hero.getAttribute('data-gtcro-price-cents') || '0', 10);
      bundle.available = hero.getAttribute('data-gtcro-available') === 'true';
      renderTotal();
    }

    // With no reviews yet, Judge.me renders a zero-count badge; hide the row.
    var badge = hero.querySelector('.jdgm-prev-badge');
    if (badge && badge.getAttribute('data-number-of-reviews') === '0') {
      var reviewsRow = hero.querySelector('.gtcro-hero__reviews');
      if (reviewsRow) reviewsRow.hidden = true;
    }

    // Swym injects a wishlist bar into the form after load and its styles
    // out-cascade the stylesheet; hide it inline whenever it appears.
    function hideSwym() {
      form.querySelectorAll('.swym-button-bar').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }
    hideSwym();
    new MutationObserver(hideSwym).observe(form, { childList: true });

    // Bundle submit: when an add-on is staged, add both lines in one
    // request, then hand the theme its own added event so the drawer opens.
    // Registered before AjaxProduct binds so it can preempt it.
    form.addEventListener('submit', function (evt) {
      var withAddon = bundle.addons.length > 0;
      var withPot = bundle.potSelected && bundle.potId;
      if (!withAddon && !withPot) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (atcBtn.classList.contains('btn--loading')) return;
      atcBtn.classList.add('btn--loading');

      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
      // Subscription widgets drop a selling_plan input into the form; keep it.
      var plan = form.querySelector('input[name="selling_plan"]:checked, input[name="selling_plan"][type="hidden"], select[name="selling_plan"]');
      if (plan && plan.value) items[0].selling_plan = plan.value;
      bundle.addons.forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });
      if (withPot) items.push({ id: bundle.potId, quantity: 1 });

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          atcBtn.classList.remove('btn--loading');
          if (data.status && data.status !== 200) {
            console.error('gt-cro bundle add failed', data);
            var msg = data.description || data.message || 'Something went wrong adding that to your basket.';
            if (hero.gtcroDropUnavailable) hero.gtcroDropUnavailable(msg);
            var note = form.querySelector('[data-gtcro-atc-note]');
            if (!note) {
              note = document.createElement('p');
              note.className = 'gtcro-atc-note';
              note.setAttribute('data-gtcro-atc-note', '');
              note.setAttribute('role', 'alert');
              atcBtn.insertAdjacentElement('afterend', note);
            }
            note.textContent = msg + ' It has been removed from your selection, please try again.';
            note.hidden = false;
            return;
          }
          var oldNote = form.querySelector('[data-gtcro-atc-note]');
          if (oldNote) oldNote.hidden = true;
          var added = (data.items && data.items[0]) || data;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: added, addToCartBtn: atcBtn },
            bubbles: true
          }));
        })
        .catch(function (err) {
          atcBtn.classList.remove('btn--loading');
          console.error('gt-cro bundle add failed', err);
        });
    });

    initAddon(hero, bundle);
    initPdpPots(hero, bundle);

    // Ajax add-to-cart through the theme's drawer when available.
    function wireAjax() {
      if (window.theme && window.theme.AjaxProduct && window.theme.settings && window.theme.settings.cartType === 'dropdown') {
        new window.theme.AjaxProduct(form, '.gtcro-atc');
        return true;
      }
      return false;
    }
    if (!wireAjax()) {
      window.addEventListener('load', wireAjax);
    }
  }

  /* ---------------- shared chooser popup (pots and accessories) ---------------- */

  // One popup, filled per use: a grid of image + name + price cards.
  // options: [{ id, title, vtitle, price (pence), img, url }], onPick(opt).
  function pickerModal() {
    var modal = document.querySelector('[data-gtpdp-pot-modal]');
    if (!modal) return null;
    if (modal.gtpdpPicker) return modal.gtpdpPicker;
    var grid = modal.querySelector('[data-gtpdp-pot-grid]');
    var note = modal.querySelector('[data-gtpdp-pot-modal-note]');
    var title = modal.querySelector('[data-gtpdp-pot-modal-title]') || modal.querySelector('h3');
    var backdrop = document.querySelector('[data-gtpdp-pot-backdrop]');
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.hidden = true;
      document.body.style.overflow = '';
    }
    var foot = modal.querySelector('[data-gtpdp-pot-foot]');
    var done = modal.querySelector('[data-gtpdp-pot-done]');
    var onDone = null;
    if (done) done.addEventListener('click', function () { close(); if (onDone) onDone(); });
    function open(cfg) {
      if (!grid) return;
      grid.innerHTML = '';
      if (title) title.textContent = cfg.title || '';
      if (note) note.textContent = cfg.note || '';
      modal.setAttribute('aria-label', cfg.title || 'Choose an option');
      var multi = !!cfg.multi;
      onDone = cfg.onDone || null;
      if (foot) foot.hidden = !multi;
      function labelDone() {
        if (!done || !multi) return;
        var n = (cfg.options || []).filter(function (o) { return cfg.isSelected(o); }).length;
        done.textContent = n ? 'Done \u00b7 ' + n + ' added' : 'Done';
      }
      (cfg.options || []).forEach(function (opt) {
        var card = document.createElement('button');
        card.type = 'button';
        var sel = multi ? cfg.isSelected(opt) : (cfg.selectedId && String(cfg.selectedId) === String(opt.id));
        card.className = 'gtpdp-pot-card' + (sel ? ' is-selected' : '');
        card.setAttribute('aria-pressed', sel ? 'true' : 'false');
        card.innerHTML = '<img alt="" loading="lazy">' +
          '<span class="gtpdp-pot-card__tick" aria-hidden="true">\u2713</span>' +
          '<span class="gtpdp-pot-card__name"></span>' +
          '<span class="gtpdp-pot-card__price"></span>';
        card.querySelector('img').src = opt.img || '';
        card.querySelector('.gtpdp-pot-card__name').textContent = opt.title + (opt.vtitle && opt.vtitle !== 'Default Title' ? ' \u00b7 ' + opt.vtitle : '');
        card.querySelector('.gtpdp-pot-card__price').textContent = formatMoney(opt.price);
        card.addEventListener('click', function () {
          if (multi) {
            var now = cfg.onToggle(opt);
            card.classList.toggle('is-selected', now);
            card.setAttribute('aria-pressed', now ? 'true' : 'false');
            labelDone();
            return;
          }
          close();
          if (cfg.onPick) cfg.onPick(opt);
        });
        grid.appendChild(card);
      });
      labelDone();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    var closeBtn = modal.querySelector('[data-gtpdp-pot-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    // The popup element covers the screen; a click on it outside the panel closes too.
    modal.addEventListener('click', function (evt) { if (evt.target === modal) close(); });
    document.addEventListener('keydown', function (evt) { if (evt.key === 'Escape') close(); });
    modal.gtpdpPicker = { open: open, close: close };
    return modal.gtpdpPicker;
  }

  /* ---------------- add-on bundle (Rebuy-driven) ---------------- */

  function initAddon(hero, bundle) {
    var card = hero.querySelector('[data-gtcro-addon]');
    if (!card) return;
    var toggle = card.querySelector('.gtcro-addon-toggle');
    var extras = hero.querySelector('[data-gtcro-addon-extras]');
    var seeAll = card.querySelector('[data-gtcro-addon-seeall]');
    var widgetId = card.getAttribute('data-widget-id');

    // Every accessory the shopper can add: the featured one on the card plus
    // anything picked in the popup. Keyed by variant id.
    var choices = [];        // in-stock products the Rebuy widget returned
    var featured = null;     // choice shown on the card (server fallback when Rebuy has nothing)
    var selected = {};       // variantId -> choice

    function firstAvailable(product) {
      for (var i = 0; i < (product.variants || []).length; i++) {
        var v = product.variants[i];
        var ok = typeof v.available === 'boolean'
          ? v.available
          : (v.inventory_policy && v.inventory_policy !== 'deny') || (parseInt(v.inventory_quantity, 10) || 0) > 0;
        if (ok && Math.round(parseFloat(v.price) * 100)) return v;
      }
      return null;
    }
    function productImage(p) {
      var src = (p.image && p.image.src) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
    }
    function choiceOf(product) {
      var v = firstAvailable(product);
      if (!v) return null;
      return { id: v.id, price: Math.round(parseFloat(v.price) * 100), title: product.title || '', vtitle: v.title && v.title !== 'Default Title' ? v.title : '', img: productImage(product), url: '/products/' + product.handle, product: product };
    }
    // A plant is never a soil, even when its tags mention one ("acid soil").
    function isPlant(product) {
      return /^plants\b/i.test(String(product.product_type || product.type || '').trim());
    }
    function isSoil(product) {
      if (isPlant(product)) return false;
      var hay = ((product.title || '') + ' ' + (product.product_type || product.type || '') + ' ' + (Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || ''))).toLowerCase();
      return /\b(soil|potting|substrate|compost|mix|perlite|bark|coir|coco|sphagnum|moss|pumice|leca|vermiculite)\b/.test(hay);
    }
    // Label for a suggestion: companion plants (outdoor), soils, or anything else.
    function labelFor(product, fallback) {
      var el = card.querySelector('[data-gtcro-addon-label]');
      if (!el || !product) return fallback;
      var key = isPlant(product) ? 'data-label-plant' : (isSoil(product) ? 'data-label-soil' : 'data-label-partner');
      return el.getAttribute(key) || fallback;
    }
    function allPlants() {
      return choices.length > 0 && choices.every(function (c) { return c.product && isPlant(c.product); });
    }

    // Server-rendered fallback (custom.preferred_soil_mix) becomes the featured choice until Rebuy answers.
    (function fromCard() {
      var id = parseInt(toggle.getAttribute('data-variant-id') || '0', 10);
      if (id > 0) {
        var link = card.querySelector('[data-gtcro-addon-link]');
        var img = card.querySelector('[data-gtcro-addon-img]');
        featured = { id: id, price: parseInt(toggle.getAttribute('data-price') || '0', 10), title: link ? link.textContent.trim() : '', vtitle: '', img: img ? img.src : '', url: link ? link.href : '#', product: null };
      }
    })();

    function syncBundle() {
      bundle.addons = Object.keys(selected).map(function (k) { return { id: selected[k].id, price: selected[k].price }; });
      if (hero.gtcroRenderTotal) hero.gtcroRenderTotal();
    }
    function paintToggle(btn, on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.innerHTML = on ? btn.getAttribute('data-label-added') : btn.getAttribute('data-label-add');
    }
    function renderExtras() {
      if (!extras) return;
      extras.innerHTML = '';
      Object.keys(selected).forEach(function (k) {
        var c = selected[k];
        if (featured && c.id === featured.id) return;
        var row = document.createElement('div');
        row.className = 'gtpdp-addon gtpdp-addon--extra is-added';
        row.innerHTML = '<img width="56" height="56" alt="" loading="lazy">' +
          '<div class="gtpdp-addon__info"><b></b><span><a></a><span class="gtpdp-addon__vt"></span> &middot; <span class="gtpdp-addon__pr"></span></span></div>' +
          '<button type="button" class="gtpdp-addon__add" data-label-add="+ Add" data-label-added="&#10003; Added" aria-pressed="true">&#10003; Added</button>';
        var im = row.querySelector('img'); im.src = c.img; im.alt = c.title;
        row.querySelector('b').textContent = c.product && (isSoil(c.product) || isPlant(c.product)) ? labelFor(c.product, 'Also added') : 'Also added';
        var a = row.querySelector('a'); a.textContent = c.title; a.href = c.url;
        row.querySelector('.gtpdp-addon__vt').textContent = c.vtitle ? ' · ' + c.vtitle : '';
        row.querySelector('.gtpdp-addon__pr').textContent = formatMoney(c.price);
        row.querySelector('button').addEventListener('click', function () { setSelected(c, false); });
        extras.appendChild(row);
      });
    }
    function setSelected(choice, on) {
      if (on) selected[choice.id] = choice; else delete selected[choice.id];
      if (featured && choice.id === featured.id) {
        card.classList.toggle('is-added', !!on);
        paintToggle(toggle, !!on);
      }
      renderExtras();
      syncBundle();
    }
    function isSelected(choice) { return !!selected[choice.id]; }
    hero.gtcroDropUnavailable = function (msg) {
      var m = /'(.+?)'/.exec(msg || '');
      var title = m ? m[1].toLowerCase() : '';
      Object.keys(selected).forEach(function (k) {
        var c = selected[k];
        if (title && c.title.toLowerCase() === title) {
          setSelected(c, false);
          choices = choices.filter(function (x) { return x.id !== c.id; });
          if (featured && featured.id === c.id && choices.length) showFeatured(choices[0]);
          else if (featured && featured.id === c.id) card.hidden = true;
          updateSeeAll();
        }
      });
    };

    toggle.addEventListener('click', function () {
      if (!featured) return;
      setSelected(featured, !isSelected(featured));
    });

    function showFeatured(choice) {
      featured = choice;
      var img = card.querySelector('[data-gtcro-addon-img]');
      var link = card.querySelector('[data-gtcro-addon-link]');
      var priceEl = card.querySelector('[data-gtcro-addon-price]');
      var labelEl = card.querySelector('[data-gtcro-addon-label]');
      var variantEl = card.querySelector('[data-gtcro-addon-variant]');
      if (img && choice.img) { img.src = choice.img.replace('width=300', 'width=112'); img.alt = choice.title; img.hidden = false; }
      if (labelEl && choice.product) labelEl.textContent = labelFor(choice.product, labelEl.textContent);
      if (link) { link.textContent = choice.title; link.href = choice.url; }
      if (priceEl) priceEl.textContent = formatMoney(choice.price);
      if (variantEl) variantEl.textContent = choice.vtitle ? ' · ' + choice.vtitle : '';
      toggle.setAttribute('data-variant-id', choice.id);
      toggle.setAttribute('data-price', choice.price);
      card.classList.toggle('is-added', isSelected(choice));
      paintToggle(toggle, isSelected(choice));
      card.hidden = false;
      renderExtras();
      syncBundle();
    }

    function updateSeeAll() {
      if (!seeAll) return;
      var others = choices.length - 1;
      seeAll.hidden = others < 1;
      var noun = allPlants() ? (others === 1 ? 'companion plant' : 'companion plants') : (others === 1 ? 'accessory' : 'accessories');
      seeAll.textContent = others > 0 ? 'See ' + others + ' other ' + noun : '';
    }
    if (seeAll) seeAll.addEventListener('click', function () {
      var picker = pickerModal();
      if (!picker || choices.length < 2) return;
      picker.open({
        title: allPlants() ? 'Plants that grow well with this one' : 'Accessories for this plant',
        note: 'Tap to add as many as you like. ' + choices.length + (allPlants() ? ' make good companions.' : ' go well with this plant.'),
        multi: true,
        options: choices,
        isSelected: isSelected,
        onToggle: function (opt) { var now = !isSelected(opt); setSelected(opt, now); return now; }
      });
    });

    if (!widgetId) return;

    function findWidget() {
      if (!window.Rebuy || !window.Rebuy.widgets) return null;
      var widgets = window.Rebuy.widgets;
      for (var key in widgets) {
        var w = widgets[key];
        if (w && String(w.id) === String(widgetId)) return w;
      }
      return null;
    }

    var probe = document.createElement('div');
    probe.setAttribute('data-rebuy-id', widgetId);
    var heroProductId = hero.getAttribute('data-product-id') || (card.getAttribute('data-product-id') || '');
    if (heroProductId) probe.setAttribute('data-rebuy-shopify-product-ids', heroProductId);
    probe.style.display = 'none';
    document.body.appendChild(probe);

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (window.Rebuy && typeof window.Rebuy.reinit === 'function' && attempts === 1) {
        try { window.Rebuy.reinit(); } catch (err) { /* widget may self-init */ }
      }
      var widget = findWidget();
      var products = widget && widget.data && widget.data.products;
      if (products && products.length) {
        clearInterval(timer);
        // Rebuy's inventory numbers can lag; confirm each product's stock with
        // the storefront before offering it, so the basket add cannot bounce.
        Promise.all(products.map(function (p) {
          return fetch('/products/' + p.handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (live) {
              if (!live) return p;
              var copy = {}; for (var k in p) copy[k] = p[k];
              copy.variants = (live.variants || []).map(function (v) {
                return { id: v.id, title: v.title, price: (v.price / 100).toFixed(2), available: !!v.available };
              });
              return copy;
            })
            .catch(function () { return p; });
        })).then(function (checked) {
          choices = checked.map(choiceOf).filter(Boolean);
          if (choices.length) showFeatured(choices[0]);
          updateSeeAll();
        });
      } else if (attempts > 20) {
        clearInterval(timer);
      }
    }, 500);
  }

  /* ---------------- PDP cache-pot add-on ---------------- */

  // Pot options come from pot_size_selection size bands embedded as JSON
  // scripts in the hero. The row shows one pot for the current plant size;
  // the popup lets the shopper pick another. Selection stages into the
  // same bundle the accessory add-on uses.
  function initPdpPots(hero, bundle) {
    var row = hero.querySelector('[data-gtpdp-pot]');
    if (!row) return;

    var img = row.querySelector('[data-gtpdp-pot-img]');
    var name = row.querySelector('[data-gtpdp-pot-name]');
    var link = row.querySelector('[data-gtpdp-pot-link]');
    var priceEl = row.querySelector('[data-gtpdp-pot-price]');
    var seeAll = row.querySelector('[data-gtpdp-pot-seeall]');
    var toggle = row.querySelector('[data-gtpdp-pot-toggle]');
    var picker = pickerModal();

    var groups = Array.prototype.slice.call(hero.querySelectorAll('[data-gtpdp-pot-group]')).map(function (s) {
      var opts;
      try { opts = JSON.parse(s.textContent); } catch (err) { opts = []; }
      return { handle: s.getAttribute('data-handle') || '', min: parseInt(s.getAttribute('data-min'), 10), max: parseInt(s.getAttribute('data-max'), 10), options: opts };
    }).filter(function (g) { return g.options.length > 0; });
    if (!groups.length) return;
    // variant id -> pot group handle, from each variant's Pot Selection metafield
    var variantMap = {};
    var mapEl = hero.querySelector('[data-gtpdp-pot-map]');
    if (mapEl) { try { variantMap = JSON.parse(mapEl.textContent) || {}; } catch (err) { variantMap = {}; } }
    // Merchandising order from the pot collection: lower position leads.
    var rank = {};
    var rankEl = hero.querySelector('[data-gtpdp-pot-rank]');
    if (rankEl) { try { rank = JSON.parse(rankEl.textContent) || {}; } catch (err) { rank = {}; } }
    groups.forEach(function (g) {
      g.options = g.options.map(function (o, i) { o._i = i; return o; }).sort(function (a, b) {
        var ra = rank[String(a.pid)] || 1e9, rb = rank[String(b.pid)] || 1e9;
        return ra - rb || a._i - b._i;
      });
    });

    var current = null;   // currently displayed pot option
    var options = [];     // options for the active size band

    function setStaged(on) {
      bundle.potSelected = on;
      row.classList.toggle('is-added', on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.innerHTML = on ? toggle.getAttribute('data-label-added') : toggle.getAttribute('data-label-add');
      if (hero.gtcroRenderTotal) hero.gtcroRenderTotal();
    }

    function showPot(opt) {
      current = opt;
      bundle.potId = opt.id;
      bundle.potPrice = opt.price;
      img.src = opt.img;
      img.alt = opt.title;
      name.textContent = opt.title + (opt.vtitle && opt.vtitle !== 'Default Title' ? ' · ' + opt.vtitle : '');
      link.href = opt.url;
      priceEl.textContent = formatMoney(opt.price);
      if (bundle.potSelected && hero.gtcroRenderTotal) hero.gtcroRenderTotal();
    }

    function updateForSize(size, variantId) {
      var g = null, handle = variantId && variantMap[String(variantId)];
      if (handle) {
        for (var h = 0; h < groups.length; h++) { if (groups[h].handle === handle) { g = groups[h]; break; } }
      }
      if (!g && !handle) {
        for (var i = 0; i < groups.length; i++) {
          if (size >= groups[i].min && size <= groups[i].max) { g = groups[i]; break; }
        }
      }
      if (!g) {
        row.hidden = true;
        if (bundle.potSelected) setStaged(false);
        bundle.potId = null;
        return;
      }
      options = g.options;
      row.hidden = false;
      if (seeAll) {
        var others = options.length - 1;
        seeAll.textContent = others > 0 ? 'See ' + others + ' other ' + (others === 1 ? 'colour or style' : 'colours and styles') : '';
        seeAll.hidden = options.length < 2;
      }
      // Keep the shopper's pot if it still fits the new size; otherwise
      // show the first option and clear any staged selection.
      var kept = null;
      if (current) {
        for (var j = 0; j < options.length; j++) {
          if (options[j].id === current.id) { kept = options[j]; break; }
        }
      }
      if (!kept && bundle.potSelected) setStaged(false);
      showPot(kept || options[0]);
    }
    hero.gtpdpUpdatePots = updateForSize;

    toggle.addEventListener('click', function () {
      if (!bundle.potId) return;
      setStaged(!bundle.potSelected);
    });

    function openModal() {
      if (!picker) return;
      picker.open({
        title: 'Pots that fit this plant',
        note: options.length + ' pots fit the selected plant size',
        selectedId: current ? current.id : null,
        options: options,
        onPick: function (opt) { showPot(opt); setStaged(true); }
      });
    }
    if (seeAll) seeAll.addEventListener('click', openModal);

    // Initialise for the size that is selected at load.
    var initialSize = parseInt(hero.getAttribute('data-gtpdp-plant-size') || '', 10);
    var initialId = hero.getAttribute('data-gtpdp-variant-id') || (hero.querySelector('input[name="id"]') || {}).value;
    updateForSize(isNaN(initialSize) ? -1 : initialSize, initialId);
  }

  /* ---------------- PDP gallery: "+N more" tile + lightbox ---------------- */

  function initPdpGallery() {
    var gal = document.querySelector('.gtpdp-gal');
    if (!gal || gal.gtpdpLightbox) return;
    gal.gtpdpLightbox = true;
    var MAX = 6;

    var lb = document.createElement('div');
    lb.className = 'gtpdp gtpdp-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product photos');
    lb.innerHTML =
      '<div class="gtpdp-lb__stage">' +
        '<span class="gtpdp-lb__count"></span>' +
        '<button type="button" class="gtpdp-lb__btn gtpdp-lb__close" aria-label="Close">&times;</button>' +
        '<button type="button" class="gtpdp-lb__btn gtpdp-lb__prev" aria-label="Previous photo">&#8249;</button>' +
        '<div class="gtpdp-lb__media"></div>' +
        '<button type="button" class="gtpdp-lb__btn gtpdp-lb__next" aria-label="Next photo">&#8250;</button>' +
      '</div>' +
      '<p class="gtpdp-lb__caption"></p>' +
      '<div class="gtpdp-lb__thumbs"></div>';
    document.body.appendChild(lb);

    var stage = lb.querySelector('.gtpdp-lb__stage');
    var mediaBox = lb.querySelector('.gtpdp-lb__media');
    var countEl = lb.querySelector('.gtpdp-lb__count');
    var captionEl = lb.querySelector('.gtpdp-lb__caption');
    var thumbsEl = lb.querySelector('.gtpdp-lb__thumbs');
    var items = [];
    var index = 0;

    function tiles() {
      return Array.prototype.slice.call(gal.querySelectorAll('.gtpdp-gal__item'));
    }

    // Shopify CDN URLs carry the size in the query (or a legacy _800x suffix);
    // ask for a larger render for the full-screen view.
    function bigSrc(img) {
      var src = img.currentSrc || img.src || '';
      return src.replace(/([?&])width=\d+/, '$1width=1600').replace(/_\d+x\.(jpe?g|png|webp)/i, '_1600x.$1');
    }

    function collect() {
      items = tiles().map(function (tile) {
        var el = tile.querySelector('img, video, iframe');
        var note = tile.querySelector('.gtpdp-gal__note');
        var caption = note && !note.hidden ? note.textContent : (el && el.alt) || '';
        return el ? { el: el, caption: caption } : null;
      }).filter(Boolean);
    }

    function renderThumbs() {
      thumbsEl.innerHTML = '';
      items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gtpdp-lb__thumb' + (i === index ? ' is-on' : '');
        b.setAttribute('aria-label', 'Photo ' + (i + 1));
        if (item.el.tagName === 'IMG') {
          var im = document.createElement('img');
          im.src = item.el.currentSrc || item.el.src;
          im.alt = '';
          b.appendChild(im);
        } else {
          var sp = document.createElement('span');
          sp.textContent = '\u25B6';
          b.appendChild(sp);
        }
        b.addEventListener('click', function () { show(i); });
        thumbsEl.appendChild(b);
      });
    }

    function show(i) {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      var item = items[index];
      mediaBox.innerHTML = '';
      var node;
      if (item.el.tagName === 'IMG') {
        node = document.createElement('img');
        node.src = bigSrc(item.el);
        node.alt = item.el.alt || '';
      } else {
        node = item.el.cloneNode(true);
        node.removeAttribute('autoplay');
      }
      mediaBox.appendChild(node);
      countEl.textContent = (index + 1) + ' / ' + items.length;
      captionEl.textContent = item.caption;
      var thumbs = thumbsEl.children;
      for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('is-on', k === index);
      if (thumbs[index] && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    function open(i) {
      collect();
      if (!items.length) return;
      index = Math.max(0, Math.min(i, items.length - 1));
      renderThumbs();
      show(index);
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.gtpdp-lb__close').focus();
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      mediaBox.innerHTML = '';
    }

    // Desktop: the sixth tile becomes the door to the rest.
    function refresh() {
      var t = tiles();
      var old = gal.querySelector('.gtpdp-gal__more');
      if (old) old.remove();
      var extra = t.length - MAX;
      gal.classList.toggle('has-more', extra > 0);
      if (extra > 0) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gtpdp-gal__more';
        btn.textContent = '+' + extra + ' more ' + (extra === 1 ? 'photo' : 'photos');
        btn.setAttribute('aria-label', 'See all ' + t.length + ' photos');
        btn.addEventListener('click', function (evt) {
          evt.stopPropagation();
          open(MAX);
        });
        t[MAX - 1].appendChild(btn);
      }
    }

    gal.addEventListener('click', function (evt) {
      var tile = evt.target.closest('.gtpdp-gal__item');
      if (!tile || !gal.contains(tile)) return;
      if (evt.target.closest('video, iframe, a, button')) return;
      open(tiles().indexOf(tile));
    });
    lb.querySelector('.gtpdp-lb__close').addEventListener('click', close);
    lb.querySelector('.gtpdp-lb__prev').addEventListener('click', function () { show(index - 1); });
    lb.querySelector('.gtpdp-lb__next').addEventListener('click', function () { show(index + 1); });
    stage.addEventListener('click', function (evt) {
      if (evt.target === stage || evt.target === mediaBox) close();
    });
    document.addEventListener('keydown', function (evt) {
      if (!lb.classList.contains('is-open')) return;
      if (evt.key === 'Escape') close();
      else if (evt.key === 'ArrowLeft') show(index - 1);
      else if (evt.key === 'ArrowRight') show(index + 1);
    });
    // Swipe between photos on touch screens.
    var touchX = null;
    mediaBox.addEventListener('touchstart', function (evt) { touchX = evt.touches[0].clientX; }, { passive: true });
    mediaBox.addEventListener('touchend', function (evt) {
      if (touchX === null) return;
      var dx = evt.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    // Customer photos arrive after load; keep the count honest.
    if ('MutationObserver' in window) new MutationObserver(refresh).observe(gal, { childList: true });
    refresh();
  }

  /* ---------------- FAQ: "Ask anything else" ---------------- */
  // Finds the best existing answers for a typed question: FAQs already on
  // the page, blog posts via Shopify predictive search (care guides, tips,
  // pest hub), and the Help & Advice Hub (fetched once, cached for a day).
  // No AI: the matches are shown as new FAQ rows with a source chip.

  function initAsk() {
    var root = document.querySelector('[data-gtpdp-ask]');
    if (!root) return;
    var form = root.querySelector('[data-gtpdp-ask-form]');
    var input = form.querySelector('input');
    var results = root.querySelector('[data-gtpdp-ask-results]');
    var status = root.querySelector('[data-gtpdp-ask-status]');
    var emptyBox = root.querySelector('[data-gtpdp-ask-empty]');
    var limit = parseInt(root.getAttribute('data-limit') || '3', 10);
    var genus = (root.getAttribute('data-genus') || '').toLowerCase();
    var common = (root.getAttribute('data-common') || '').toLowerCase();
    var pTitle = (root.getAttribute('data-title') || '').toLowerCase();
    var pType = (root.getAttribute('data-type') || '').toLowerCase();
    var pTags = (root.getAttribute('data-tags') || '').toLowerCase().split('|').map(function (t) { return t.replace(/^[a-z ]+:\s*/, '').trim(); }).filter(Boolean);
    /* Plant names that identify a different plant from the one on this page. A guide
       whose title names another plant is pushed down; one naming this plant is lifted. */
    var GENERA = ['alocasia','anthurium','monstera','philodendron','spathiphyllum','peace lily','calathea','goeppertia','maranta','prayer plant','stromanthe','ctenanthe','hoya','wax plant','epipremnum','pothos','scindapsus','syngonium','arrowhead','begonia','ficus','fiddle leaf','rubber plant','dracaena','sansevieria','snake plant','zamioculcas','zz plant','aglaonema','dieffenbachia','peperomia','pilea','tradescantia','oxalis','caladium','colocasia','cactus','cacti','succulent','orchid','phalaenopsis','fern','palm','areca','kentia','yucca','strelitzia','bird of paradise','musa','banana','citrus','olive','hedera','ivy','senecio','string of pearls','ceropegia','string of hearts','rhaphidophora','amydrium','stephania','bonsai','tillandsia','air plant','bromeliad','croton','codiaeum','schefflera','aspidistra','chlorophytum','spider plant','cyclamen','kalanchoe','echeveria','haworthia','aloe','agave','euphorbia','lithops','venus flytrap','dionaea','nepenthes','sarracenia','carnivorous','tetrastigma','fatsia','trachycarpus','dicksonia','tree fern','ensete','canna','hedychium','ginger','tetrapanax','bamboo','phyllostachys','gunnera','eucomis','zantedeschia','arisaema','amorphophallus','sauromatum','impatiens','hosta','brugmansia','dahlia','salvia','melianthus','paulownia','cordyline','phormium','persicaria','podophyllum','farfugium','rodgersia','ligularia','fuchsia','passiflora','anthemis','hibiscus','hydrangea','acer','magnolia','camellia','rhododendron','azalea','lavender','rosemary','jasmine','clematis','wisteria','rose','tulip','daffodil','narcissus','lily','alstroemeria','agapanthus','crocosmia','kniphofia','iris','geranium','pelargonium','petunia','tomato','chilli','pepper','herb','basil','mint','philodendron','thaumatophyllum','homalomena','aglaonema','epiphyllum','rhipsalis','schlumbergera','christmas cactus','hoya','dischidia','peperomia','nepenthes','platycerium','staghorn','asplenium','nephrolepis','boston fern','adiantum','maidenhair','polypodium','microsorum','selaginella','fittonia','nerve plant','hypoestes','polka dot','coleus','plectranthus','solenostemon','aeschynanthus','lipstick plant','columnea','episcia','streptocarpus','saintpaulia','african violet','sinningia','gloxinia','cissus','monstera adansonii','swiss cheese','thai constellation','albo','yucca','beaucarnea','ponytail palm','pachira','money tree','crassula','jade','sedum','sempervivum','graptopetalum','pachyphytum','gasteria','adenium','desert rose','plumeria','frangipani','pandanus','cycas','cycad','zamia','dioon','encephalartos','asparagus fern','cyperus','papyrus','equisetum','nymphaea','waterlily','pistia','eichhornia','marimo','anubias','bucephalandra','cryptocoryne'];
    var mine = [genus, common].filter(Boolean);
    var others = GENERA.filter(function (g) {
      if (!g) return false;
      if (mine.some(function (m) { return m.indexOf(g) > -1 || g.indexOf(m) > -1; })) return false;
      return pTitle.indexOf(g) === -1;
    });

    /* ---- Matching: the words shoppers use, not the letters they type.
       Light stemming, a synonym list, and a typo tolerance against the
       words that actually appear in the candidate answers. Every real
       word in the question has to land, so results stay close matches. */
    var STOP = /^(the|and|for|with|that|this|from|what|does|will|have|has|can|are|its|how|why|when|should|would|could|about|into|your|you|our|my|me|is|do|of|to|in|on|a|an|or|be|if|at|as|so|any|not|too|very|much|many|get|got|i|it|we|us|they|them|there|here|please|want|need|like|just|also|still|yet|did|was|were|been|being|am|but|by|up|out|wo|ca|sha|where|hasnt|havent|isnt|dont|doesnt|didnt|wont|cant|wasnt|couldnt|wouldnt|shouldnt|im|ive|id|whats|wheres|plant|plants)$/;
    var SYN = [
      ['shipping','ship','delivery','deliver','delivered','dispatch','dispatched','post','postage','courier','parcel','package','send','sent','arrive','arrival','arrived','dpd','royal mail','evri','yodel'],
      ['track','tracking','where is my order','where is my parcel','where is my delivery','status','eta','late','delayed','delay','waiting','overdue','received','receive'],
      ['missing','lost','stolen','not arrived','never arrived','hasnt arrived','not received','disappeared','gone','says delivered'],
      ['refund','refunded','money back','reimburse','chargeback','credit'],
      ['return','returns','send back','exchange','swap','replacement','replace'],
      ['cancel','cancellation','cancelled','stop','undo'],
      ['change','edit','amend','update','modify','wrong','mistake','incorrect'],
      ['address','postcode'],
      ['discount','code','voucher','coupon','promo','promotion','offer','sale','deal','student','nhs'],
      ['points','reward','rewards','loyalty','growth fund','tier','earn','redeem'],
      ['damaged','damage','broken','snapped','crushed','squashed','bent','dead','died','dying','poorly','wilted','wilting','rotten','rot','mushy'],
      ['guarantee','warranty','live arrival','promise','protect','protection','insurance','cover','covered'],
      ['pest','pests','bug','bugs','insect','insects','thrips','mealybug','mealybugs','spider mite','mites','gnat','gnats','fungus','aphid','aphids','scale','infestation','infested'],
      ['yellow','yellowing','brown','browning','crispy','crisp','spots','spotting','drooping','droopy','limp','curling','leaf','leaves'],
      ['size','sizes','cm','big','small','large','tall','height','measure','measurement','dimensions','diameter','width'],
      ['pot','pots','planter','planters','container','nursery pot','decorative','ceramic'],
      ['repot','repotting','transplant','pot up','pot on'],
      ['soil','substrate','compost','potting mix','mix','bark','perlite','coco','coir','peat','leca','pon','sphagnum','moss'],
      ['water','watering','overwater','overwatered','overwatering','underwater','underwatered','thirsty','dry','moist','wet','soggy'],
      ['light','sun','sunlight','sunny','shade','shady','bright','dark','window','grow light','led'],
      ['humidity','humid','mist','misting','humidifier','dry air'],
      ['feed','feeding','fertiliser','fertilizer','fertilise','fertilize','food','plant food','nutrients','nutrient','npk'],
      ['temperature','cold','frost','frosty','freezing','winter','heat','hot','heat pack','heatpack','warm','weather','snow','hardy','hardiness'],
      ['toxic','toxicity','poison','poisonous','pet','pets','cat','cats','dog','dogs','child','children','kids','baby','toddler'],
      ['pay','payment','paid','charge','charged','card','klarna','clearpay','paypal','apple pay','google pay','shop pay','instalment','instalments','installments','split'],
      ['invoice','receipt','vat','tax','confirmation','confirm','email'],
      ['account','login','log in','sign in','password','register','registration','guest'],
      ['wholesale','trade','business','bulk','b2b','office','hotel','restaurant','corporate'],
      ['subscription','subscribe','subscriber','monthly','box','skip','pause','frequency'],
      ['tissue culture','tc','plantlet','plantlets','pre-order','preorder','pre order','lab','flask','acclimate','acclimatise','acclimatize'],
      ['rescue','rescue box','mystery','mystery box','bargain','clearance','reduced','imperfect'],
      ['gift','present','someone else','birthday','message','card','note'],
      ['holiday','holidays','away','vacation','trip','travel','travelling','hold','postpone','later'],
      ['collect','collection','pickup','pick up','click and collect','visit','shop','store','nursery','york'],
      ['sustainability','sustainable','eco','plastic','packaging','recycle','recycled','recyclable','peat free','peat-free','carbon'],
      ['stock','restock','restocked','sold out','out of stock','available','availability','back in','notify','waitlist'],
      ['order','ordered','ordering','purchase','purchased','buy','bought','checkout','basket','cart'],
      ['saturday','weekend','next day','express','priority','fast','quick','quickly','same day','how long','slot'],
      ['country','countries','international','abroad','europe','eu','ireland','northern ireland','scotland','highlands','overseas','export'],
      ['plant out','planting','outdoor','outdoors','outside','garden','border','ground','depth','deep'],
      ['care','look after','instructions','guide','how to','tips','advice','help'],
      ['flower','flowers','flowering','bloom','blooms','fruit','fruiting'],
      ['propagate','propagation','cutting','cuttings','node','root','roots','rooting','divide','division','offset','pup','pups'],
      ['variegated','variegation','variegata','albo','aurea','revert','reverting'],
      ['grow','growth','growing','new leaf','unfurl','unfurling','slow','fast growing','mature','maturity','fenestration','fenestrate','split','splits','holes']
    ];
    function stem(w) {
      w = w.replace(/'s$/, '');
      if (w.length <= 3) return w;
      var r = w;
      if (/ies$/.test(r) && r.length > 4) r = r.replace(/ies$/, 'y');
      else if (/sses$/.test(r)) r = r.replace(/es$/, '');
      else if (/(ches|shes|xes)$/.test(r)) r = r.replace(/es$/, '');
      else if (/s$/.test(r) && !/ss$/.test(r)) r = r.replace(/s$/, '');
      if (r.length > 5 && /ing$/.test(r)) r = r.replace(/ing$/, '');
      else if (r.length > 4 && /ed$/.test(r)) r = r.replace(/ed$/, '');
      if (r.length > 4 && /([b-df-hj-np-tv-z])\1$/.test(r)) r = r.slice(0, -1);
      if (r.length > 5 && /ly$/.test(r)) r = r.replace(/ly$/, '');
      if (r.length > 4 && /e$/.test(r)) r = r.replace(/e$/, '');
      return r;
    }
    function tokens(str) {
      return (str.toLowerCase().replace(/[’‘]/g, "'").replace(/n't\b/g, '').replace(/'(s|re|ve|ll|d|m)\b/g, '').replace(/-/g, ' ').match(/[a-z0-9]+/g) || []).filter(function (w) { return w.length > 1 && !STOP.test(w); });
    }
    function allWords(str) {
      return (str.toLowerCase().replace(/[’‘]/g, "'").replace(/'(s|re|ve|ll|d|m)\b/g, '').replace(/-/g, ' ').match(/[a-z0-9]+/g) || []).filter(function (w) { return w.length > 1; });
    }
    function uniq(arr) { var o = {}, out = []; arr.forEach(function (x) { if (!o[x]) { o[x] = 1; out.push(x); } }); return out; }
    var synIndex = {}, phrases = [];
    SYN.forEach(function (group, gi) {
      group.forEach(function (term) {
        if (term.indexOf(' ') > -1) phrases.push({ p: term, g: gi });
        else { var st = stem(term); (synIndex[st] = synIndex[st] || []).push(gi); }
      });
    });
    function synonymsOf(st) {
      var out = [];
      (synIndex[st] || []).forEach(function (gi) { SYN[gi].forEach(function (t) { if (t.indexOf(' ') === -1) out.push(stem(t)); }); });
      return out;
    }
    function editDistance(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var d = [], i, j;
      for (i = 0; i <= a.length; i++) { d[i] = [i]; }
      for (j = 0; j <= b.length; j++) { d[0][j] = j; }
      for (i = 1; i <= a.length; i++) {
        var rowMin = Infinity;
        for (j = 1; j <= b.length; j++) {
          var cost = a[i - 1] === b[j - 1] ? 0 : 1;
          var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
          if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2][j - 2] + 1);
          d[i][j] = v; if (v < rowMin) rowMin = v;
        }
        if (rowMin > max) return max + 1;
      }
      return d[a.length][b.length];
    }
    function fuzzy(st, vocab) {
      if (st.length < 4) return [];
      var max = st.length >= 6 ? 2 : 1, out = [];
      vocab.forEach(function (v) { if (v !== st && v.length >= 3 && editDistance(st, v, max) <= max) out.push(v); });
      return out;
    }
    function hasWord(list, st, allowPrefix) {
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (v === st) return 2;
        if (allowPrefix && st.length >= 4 && v.length >= 4 && (v.indexOf(st) === 0 || st.indexOf(v) === 0)) return 1;
      }
      return 0;
    }
    /* Build the query terms once per keystroke; the fuzzy pass uses the vocabulary of the candidates. */
    function expand(q, vocab) {
      var lower = q.toLowerCase(), phraseGroups = [];
      phrases.forEach(function (ph) { if (lower.indexOf(ph.p) > -1) phraseGroups.push(ph.g); });
      var terms = tokens(q).map(function (w) {
        var st = stem(w), syn = synonymsOf(st);
        var fz = (vocab[st] || syn.length) ? [] : fuzzy(st, Object.keys(vocab));
        return { stem: st, exact: [st], near: uniq(syn.concat(fz)) };
      });
      phraseGroups.forEach(function (gi) {
        terms.push({ stem: '', exact: [], near: SYN[gi].filter(function (t) { return t.indexOf(' ') === -1; }).map(stem), phrase: true });
      });
      return terms;
    }
    function scoreItem(it, terms, lower) {
      var score = 0, matched = 0, need = 0, titleHits = 0;
      terms.forEach(function (t) {
        if (!t.phrase) need++;
        var best = 0;
        t.exact.forEach(function (st) {
          var a = hasWord(it.tw, st, true); if (a) { best = Math.max(best, a === 2 ? 3 : 2); titleHits++; }
          var b = hasWord(it.bw, st, true); if (b) best = Math.max(best, b === 2 ? 1.5 : 1);
        });
        if (!best) t.near.forEach(function (st) {
          var a = hasWord(it.tw, st, false); if (a) best = Math.max(best, 1.4);
          var b = hasWord(it.bw, st, false); if (b) best = Math.max(best, 0.5);
        });
        if (best) { score += best; if (!t.phrase) matched++; else score += 0.3; }
      });
      if (lower.length > 3 && it.title.toLowerCase().indexOf(lower) > -1) score += 4;
      return { score: score, matched: matched, need: need, titleHits: titleHits };
    }
    function indexItem(h) {
      h.tw = uniq(tokens(h.title || '').map(stem));
      h.bw = uniq(tokens(h.body || '').map(stem));
      h.taw = uniq(allWords(h.title || ''));
      h.raw = uniq(tokens(h.title || '').concat(tokens(h.body || '')));
      return h;
    }

    function textOf(html) {
      var d = document.createElement('div');
      d.innerHTML = html || '';
      return (d.textContent || '').replace(/\s+/g, ' ').trim();
    }
    function excerpt(text, n) {
      text = text || '';
      if (text.length <= n) return text;
      var cut = text.slice(0, n);
      var i = cut.lastIndexOf('. ');
      return (i > n * 0.5 ? cut.slice(0, i + 1) : cut.replace(/\s+\S*$/, '') + '…');
    }
    function sourceOf(url) {
      if (url.indexOf('/blogs/help-centre') > -1) return 'Help centre';
      if (url.indexOf('houseplant-care-a-z') > -1) return 'Care guide';
      if (url.indexOf('houseplant-tips-tricks') > -1) return 'Tips & tricks';
      if (url.indexOf('houseplant-pests') > -1) return 'Pest hub';
      if (url.indexOf('the-uncommon-garden') > -1) return 'Growing guide';
      if (url.indexOf('/blogs/') > -1) return 'From the blog';
      if (url.indexOf('/pages/') > -1) return 'Info page';
      return 'FAQ';
    }

    var tagWords = [];
    pTags.concat([pType]).forEach(function (t) { tokens(t).forEach(function (w) { if (w.length > 3) tagWords.push(stem(w)); }); });
    tagWords = uniq(tagWords);

    /* Spelling: a vocabulary of the words that appear in the answers, the synonym
       list and plant names, with counts, so a typo can be corrected before we
       ask Shopify's search for guides. */
    var baseVocab = null;
    function vocabCounts(items) {
      if (!baseVocab) {
        baseVocab = {};
        SYN.forEach(function (g) { g.forEach(function (t) { tokens(t).forEach(function (w) { var st = stem(w); baseVocab[st] = (baseVocab[st] || 0) + 1; }); }); });
        GENERA.forEach(function (g) { tokens(g).forEach(function (w) { var st = stem(w); baseVocab[st] = (baseVocab[st] || 0) + 2; }); });
        mine.forEach(function (m) { tokens(m).forEach(function (w) { baseVocab[stem(w)] = (baseVocab[stem(w)] || 0) + 5; }); });
      }
      var v = {};
      Object.keys(baseVocab).forEach(function (k) { v[k] = baseVocab[k]; });
      items.forEach(function (it) { it.tw.forEach(function (w) { v[w] = (v[w] || 0) + 3; }); it.bw.forEach(function (w) { v[w] = (v[w] || 0) + 1; }); });
      return v;
    }
    var baseRaw = null;
    function rawCounts(items) {
      if (!baseRaw) {
        baseRaw = {};
        SYN.forEach(function (g) { g.forEach(function (t) { tokens(t).forEach(function (w) { baseRaw[w] = (baseRaw[w] || 0) + 1; }); }); });
        GENERA.forEach(function (g) { tokens(g).forEach(function (w) { baseRaw[w] = (baseRaw[w] || 0) + 2; }); });
        mine.forEach(function (m) { tokens(m).forEach(function (w) { baseRaw[w] = (baseRaw[w] || 0) + 5; }); });
      }
      var v = {};
      Object.keys(baseRaw).forEach(function (k) { v[k] = baseRaw[k]; });
      items.forEach(function (it) { it.raw.forEach(function (w) { v[w] = (v[w] || 0) + 1; }); });
      return v;
    }
    function bestCorrection(st, vocab) {
      if (st.length < 4 || vocab[st]) return null;
      var max = st.length >= 6 ? 2 : 1, best = null;
      if (st.length >= 5) max = Math.max(max, 1);
      Object.keys(vocab).forEach(function (v) {
        if (v.length < 3) return;
        var d = editDistance(st, v, max);
        if (d > max) return;
        var sameStart = v[0] === st[0] ? 1 : 0;
        var cand = { w: v, d: d, n: vocab[v], s: sameStart };
        if (!best || cand.d < best.d || (cand.d === best.d && (cand.s > best.s || (cand.s === best.s && cand.n > best.n)))) best = cand;
      });
      return best && best.w;
    }
    /* Rewrite the shopper's words with their corrected stems where a word is unknown. */
    function correctedQuery(q, raw) {
      var changed = false;
      var out = (q.match(/[A-Za-z0-9']+|[^A-Za-z0-9']+/g) || []).map(function (piece) {
        if (!/[a-z]/i.test(piece)) return piece;
        var w = piece.toLowerCase();
        if (STOP.test(w) || w.length < 4) return piece;
        if (raw[w]) return piece;
        var c = bestCorrection(w, raw);
        if (!c) return piece;
        changed = true;
        return c;
      }).join('');
      return changed ? out : null;
    }

    // 1. FAQs already on the page, indexed once (used for spelling only; they are already visible above)
    var localItems = null;
    function localIndex() {
      if (localItems) return localItems;
      localItems = Array.prototype.slice.call(document.querySelectorAll('.gtpdp-faq__item:not(.gtpdp-ask__hit)')).map(function (d) {
        var title = ((d.querySelector('summary') || {}).textContent || '').trim();
        var body = ((d.querySelector('.gtpdp-acc__body') || {}).textContent || '').replace(/\s+/g, ' ').trim();
        return indexItem({ title: title, body: body, url: '', source: 'FAQ', el: d });
      });
      return localItems;
    }

    // 1b. The Help Centre, fetched once per session so its answers are instant and typo tolerant
    var hubUrl = root.getAttribute('data-hub-url') || '/blogs/help-centre';
    var hubItems = null, hubPromise = null;
    function hubIndex() {
      if (hubPromise) return hubPromise;
      try {
        var c = JSON.parse(sessionStorage.getItem('gtpdpHub2') || 'null');
        if (c && c.t && Date.now() - c.t < 864e5 && c.items && c.items.length) { hubItems = c.items.map(indexItem); return (hubPromise = Promise.resolve(hubItems)); }
      } catch (e) {}
      hubPromise = fetch(hubUrl, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = [];
        doc.querySelectorAll('[data-help-item]').forEach(function (d) {
          var t = d.querySelector('summary > span'), b = d.querySelector('.gt-help__answer .rte'), a = d.querySelector('.gt-help__permalink');
          if (!t || !b) return;
          items.push({ title: t.textContent.trim(), body: (b.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 600), url: a ? a.getAttribute('href') : hubUrl + '#' + d.id, source: 'Help centre' });
        });
        try { sessionStorage.setItem('gtpdpHub2', JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        hubItems = items.map(indexItem);
        return hubItems;
      }).catch(function () { hubItems = []; return hubItems; });
      return hubPromise;
    }
    input.addEventListener('focus', function () { hubIndex(); }, { once: true });

    // 2. Blog + pages through predictive search (plain, and biased to this plant)
    var predCache = {};
    function predictive(q, fixed) {
      var key = q + '|' + (fixed || '');
      if (predCache[key]) return Promise.resolve(predCache[key]);
      var qs = [fixed || q];
      if (fixed && fixed !== q) qs.push(q);
      if (genus && (fixed || q).toLowerCase().indexOf(genus) === -1) qs.push(genus + ' ' + (fixed || q));
      return Promise.all(qs.map(function (query) {
        var u = '/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=article,page&resources[limit]=8&resources[options][fields]=title,body';
        return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (all) {
        var seen = {}, out = [];
        all.forEach(function (d, pass) {
          if (!d || !d.resources || !d.resources.results) return;
          var r = d.resources.results;
          (r.articles || []).concat(r.pages || []).forEach(function (a, i) {
            var url = (a.url || '').split('?')[0];
            if (!url || seen[url]) return;
            seen[url] = 1;
            out.push(indexItem({ title: a.title || '', body: textOf(a.summary_html || a.body || ''), url: url, source: sourceOf(url), rank: i, pass: pass, mine: pass === qs.length - 1 && qs.length > 1 }));
          });
        });
        predCache[key] = out;
        return out;
      });
    }

    function vocabOf(items) {
      var v = {};
      items.forEach(function (it) { it.tw.concat(it.bw).forEach(function (w) { v[w] = 1; }); });
      return v;
    }
    /* Strict: every real word in the question must match; then rank. */
    function rank(q, items) {
      var terms = expand(q, vocabCounts(items));
      var need = terms.filter(function (t) { return !t.phrase; }).length;
      if (!need && !terms.length) return [];
      var lower = q.toLowerCase();
      var hits = [];
      items.forEach(function (it) {
        var r = scoreItem(it, terms, lower);
        if (need ? r.matched < need : r.score <= 0) return;
        var sc = r.score;
        var t = it.title.toLowerCase(), bl = it.body.toLowerCase();
        if (it.source === 'Help centre' && it.rank === undefined) sc += 1;
        else if (it.url) {
          sc += (8 - Math.min(it.rank || 0, 7)) * 0.05;          // Shopify's order as a tiebreaker
          if (it.mine) sc += 0.3;
          if (it.url.indexOf('/blogs/help-centre/') > -1) sc += 1;
        }
        // Page context: this plant's name lifts a guide, another plant's name in the title sinks it
        var named = mine.some(function (m) { return t.indexOf(m) > -1; });
        if (named) sc += r.titleHits ? 2 : 0.8;                  // this plant's own guide, but only ahead of generic ones when the question is in its title
        sc -= Math.min(it.taw.length, 14) * 0.02;                // shorter, more direct titles first among equals
        var qa = allWords(lower), hitsAll = 0;
        qa.forEach(function (w) { if (it.taw.indexOf(w) > -1 || (w.length >= 4 && it.taw.some(function (x) { return x.indexOf(w) === 0 || w.indexOf(x) === 0 && x.length >= 4; }))) hitsAll++; });
        if (qa.length) sc += (hitsAll / qa.length) * 2;
        else if (mine.some(function (m) { return bl.indexOf(m) > -1; })) sc += 1;
        if (!named && others.some(function (g) { return t.indexOf(g) > -1; })) sc -= 2.5;
        var tagHits = 0;
        tagWords.forEach(function (w) { if (tagHits < 2 && hasWord(it.tw, w, false)) tagHits++; });
        sc += tagHits * 0.6;
        hits.push({ it: it, score: sc });
      });
      hits.sort(function (a, b) { return b.score - a.score; });
      var seen = {}, top = [];
      hits.forEach(function (h) {
        var k = h.it.title.toLowerCase();
        if (seen[k] || top.length >= limit) return;
        seen[k] = 1; top.push(h.it);
      });
      return top;
    }

    function render(hits) {
      results.innerHTML = '';
      hits.forEach(function (h, i) {
        var d = document.createElement('details');
        d.className = 'gtpdp-acc gtpdp-faq__item gtpdp-ask__hit';
        if (i === 0) d.open = true;
        d.style.animationDelay = (i * 60) + 'ms';
        var sm = document.createElement('summary');
        var t = document.createElement('span');
        t.textContent = h.title;
        var chip = document.createElement('span');
        chip.className = 'gtpdp-ask__chip';
        chip.textContent = h.source;
        sm.appendChild(t); sm.appendChild(chip);
        var body = document.createElement('div');
        body.className = 'gtpdp-acc__body';
        var p = document.createElement('p');
        p.textContent = excerpt(h.body, 320) || 'Open the full answer below.';
        body.appendChild(p);
        if (h.url) {
          var a = document.createElement('a');
          a.className = 'gtpdp-ask__more';
          a.href = h.url;
          a.textContent = h.source === 'Help centre' ? 'Read the full answer →' : 'Read the full article →';
          body.appendChild(a);
        } else if (h.el) {
          var b = document.createElement('a');
          b.className = 'gtpdp-ask__more';
          b.href = '#';
          b.textContent = 'See the full answer above →';
          b.addEventListener('click', function (evt) {
            evt.preventDefault();
            h.el.open = true;
            h.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          body.appendChild(b);
        }
        d.appendChild(sm); d.appendChild(body);
        results.appendChild(d);
      });
    }
    function setStatus(text, busy) {
      status.textContent = text || '';
      status.hidden = !text;
      status.classList.toggle('is-busy', !!busy);
      root.classList.toggle('is-busy', !!busy);
    }
    function showEmpty(on) { if (emptyBox) emptyBox.hidden = !on; }
    function reset() { results.innerHTML = ''; setStatus('', false); showEmpty(false); }

    var seq = 0, timer = null;
    function search(q) {
      var my = ++seq;
      if (q.length < 3 || !tokens(q).length) { reset(); return; }
      // Instant pass over this page's FAQs, then merge the guides when they arrive.
      var local = rank(q, hubItems || []);
      showEmpty(false);
      render(local);
      setStatus(local.length ? '' : (root.getAttribute('data-status') || 'Looking through our guides'), true);
      hubIndex().then(function (hubList) {
        if (my !== seq) return null;
        var fixed = correctedQuery(q, rawCounts(localIndex().concat(hubList)));
        return Promise.all([predictive(q, fixed), hubList, fixed]);
      }).then(function (parts) {
        if (!parts || my !== seq) return;
        // Help Centre answers already indexed locally win over the same answer from predictive search
        var remote = parts[0].filter(function (r) { return r.url.indexOf('/blogs/help-centre/') === -1; });
        var top = rank(parts[2] || q, parts[1].concat(remote));
        setStatus('', false);
        render(top);
        showEmpty(!top.length);
      }).catch(function () {
        if (my !== seq) return;
        setStatus('', false);
        showEmpty(!local.length);
      });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = (input.value || '').trim();
      if (q.length < 3) { seq++; reset(); return; }
      timer = setTimeout(function () { search(q); }, 220);
    });
    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      clearTimeout(timer);
      var q = (input.value || '').trim();
      if (q.length < 3) { input.focus(); return; }
      search(q);
    });
  }

  /* ---------------- dispatch countdown ---------------- */

  function initDispatch() {
    var el = document.querySelector('[data-gtcro-dispatch]');
    if (!el) return;
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour') || '14', 10);

    function ukNow() {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
    }

    function render() {
      var now = ukNow();
      var day = now.getDay();
      var isWeekday = day >= 1 && day <= 5;
      if (isWeekday && now.getHours() < cutoff) {
        var target = new Date(now);
        target.setHours(cutoff, 0, 0, 0);
        var diff = target - now;
        var hrs = Math.floor(diff / 3600000);
        var mins = Math.max(1, Math.floor((diff % 3600000) / 60000));
        var countdown = (hrs > 0 ? hrs + 'h ' : '') + mins + 'm';
        el.textContent = (el.getAttribute('data-text-before') || '').replace('[countdown]', countdown);
      } else if (day >= 5 || day === 0) {
        el.textContent = el.getAttribute('data-text-weekend') || el.textContent;
      } else {
        el.textContent = el.getAttribute('data-text-after') || el.textContent;
      }
    }

    render();
    setInterval(render, 60000);
  }

  /* ---------------- size guide drawer ---------------- */

  function initSizeGuide() {
    var drawer = document.getElementById('gtcroSizeGuide');
    var backdrop = document.getElementById('gtcroSizeGuideBackdrop');
    if (!drawer || !backdrop) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-gtcro-size-guide]')) { open(); return; }
      if (evt.target.closest('.gtcro-sg__close') || evt.target === backdrop) close();
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') close();
    });
  }

  /* ---------------- sticky bar ---------------- */

  function initSticky() {
    var bar = document.querySelector('.gtcro-sticky');
    var buybox = document.getElementById('gtcro-buybox');
    if (!bar || !buybox) return;

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
    }, { threshold: 0 });
    observer.observe(buybox);
  }

  /* ---------------- boot ---------------- */

  function init() {
    document.querySelectorAll('.gtcro-gal').forEach(initGallery);
    document.querySelectorAll('.gtcro-hero').forEach(initBuybox);
    initSticky();
    initPdpGallery();
    initAsk();
    initDispatch();
    initSizeGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
